import { createSvgComponent } from "../../icon/createSvgComponent";
import AiSpark from "@core/icon/assets/ai-spark.svg";
export default createSvgComponent(AiSpark);